module.exports = __webpack_public_path__ + "134f3a44e27e46a9a14e7c4705c3799d.png";